import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MD_DIALOG_DATA, MdDialog, MdDialogRef } from '@angular/material';

import { DialogConfirmComponentComponent } from '../../dialog-confirm-component/dialog-confirm-component.component';
import { AppMessage } from './../../../Common/appMessage';
import { Utility } from './../../../Common/Services/utility';
import { AdmRemoveOfficeService } from './adm-remove-office.service';

@Component({
  selector: 'app-adm-remove-office',
  templateUrl: './adm-remove-office.component.html',
  styleUrls: ['./adm-remove-office.component.css'],
  providers: [AdmRemoveOfficeService]
})
export class AdmRemoveOfficeComponent implements OnInit {
  officeData: any;
  form: FormGroup;
  showOfficeList: any;
  constructor(
    public dialogRef: MdDialogRef<AdmRemoveOfficeComponent>,
    @Inject(MD_DIALOG_DATA) public data: any,
    public _utility: Utility, public _dialog: MdDialog, public _appMessage: AppMessage, private _service: AdmRemoveOfficeService
  ) {

    this.officeData = data;
    this.form = new FormGroup({
      newOffice: new FormControl(),
      selectOffice: new FormControl()
    });

  }
  ngOnInit() {
    this.showOfficeList = this.duplicateArray(this.officeData.officeList);
    this.showOfficeList = this.showOfficeList.filter(elm => {
      return elm.id !== this.officeData.element.id
    })
    this.form.controls.newOffice.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe(value => {
        let field = this.form.controls.selectOffice;
        if (value) {
          field.disable();
          field.reset();
        } else {
          field.enable();
        }
      });
  }

  duplicateArray(array) {
    let arr = [];
    array.forEach((x) => {
      arr.push((<any>Object).assign({}, x));
    })

    return arr;
  }
  // To close the current dialog
  closeDialog(dialogResult: any = 0) {
    this.dialogRef.close(dialogResult);
  }

  onDelete(): void {
    let instance = this._dialog.openDialogs[0];
    this._dialog.openDialogs.pop();//to clear instance of first dialog box to opne another on it(issue i IE,edge and safari) 
    let confirmDialogMsgModel = {
      modelType: "CONFIRMATION",
      msgTitle: this._appMessage.getItem['Common007'],
      msg: this._appMessage.getItem['UMsg00063'],
      isConfirmBox: true,
      confirmBtnCaption: this._appMessage.getItem['Common014'],//'Yes',
      cancelBtnCaption: this._appMessage.getItem['Common015'],//'No'
    };
    this._dialog.openDialogs.pop();
    let confirmDialogMsgRef = this._dialog.open(DialogConfirmComponentComponent,
      {
        data: confirmDialogMsgModel
      });
    confirmDialogMsgRef.afterClosed().subscribe(result => {
      if (result == "1") {
        this._utility.addLoaderCount();
        this._service.deleteOffice(this.officeData.element.id).subscribe(response => {
          this._utility.onSuccessCallback(response, this._appMessage.getItem['UMsg00064'], function () {
            this.closeDialog(true); // we are passing true : based on this value , we will load grid
          }.bind(this));

        }, error => this._utility.onErrorCallback(error));
      }
    });
    this._dialog.openDialogs.push(instance); //popped instance pushed again to maintain its normal behavior
  }

  /**
   * We can replace with new added office value
   * We can replace office by selecting any other office 
   */
  onReplace(): void {
    let instance = this._dialog.openDialogs[0];
    this._dialog.openDialogs.pop();//to clear instance of first dialog box to opne another on it(issue i IE,edge and safari) 
    let values = this.form.getRawValue();
    let params;
    if (values.newOffice) {
      params = { officeName: values.newOffice, officeId: this.officeData.element.id };
    } else if (values.selectOffice) {
      params = { selectedOfficeId: values.selectOffice.id, officeId: this.officeData.element.id };
    }
    this._utility.addLoaderCount();
    this._service.replaceOffice(params).subscribe(response => {
      this._utility.onSuccessCallback(response, this._appMessage.getItem['UMsg00065'], function () {
        this.closeDialog(true);
      }.bind(this));
    }, error => this._utility.onErrorCallback(error));
    this._dialog.openDialogs.push(instance); //popped instance pushed again to maintain its normal behavior
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-office/adm-remove-office/adm-remove-office.component.ts